var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.67063 7.42506L1.24557 0L0 1.24557L7.42506 8.67063L7.28003 8.81566L7.32838 8.86401L0 16.1924L1.24557 17.438L8.57395 10.1096L15.999 17.5346L17.2446 16.2891L9.81952 8.86401L9.96455 8.71898L9.9162 8.67063L17.2446 1.34225L15.999 0.0966774L8.67063 7.42506Z","fill":"currentColor"}));
}

Close.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Close;

Close.default = Close;
